import { createFileRoute, redirect } from '@tanstack/react-router';
import { ONBOARDING_STEPS } from 'components/pages/onboarding-my-plan/steps';
import { lazy, Suspense } from 'react';
import { onboardingLoaderSearchSchema } from 'router/schemas';

const OnboardingLoader = lazy(() => import('pages/onboarding-loader'));

export const Route = createFileRoute('/_authenticated/_onboarding/onboarding/loader/')({
  validateSearch: onboardingLoaderSearchSchema,
  beforeLoad: ({ search, location }) => {
    const { step } = search;
    const stepConfig = ONBOARDING_STEPS[step - 1];

    if (!stepConfig?.loader || !(location.state as unknown as Record<string, unknown>)?.fromOnboarding) {
      throw redirect({
        to: '/onboarding/my-plan/$step',
        // @ts-expect-error strictNullChecks breaks TanStack Router inference
        params: { step },
      });
    }
  },
  component: OnboardingLoaderWrapper,
});

function OnboardingLoaderWrapper() {
  const { step } = Route.useSearch();

  return (
    <Suspense fallback={null}>
      <OnboardingLoader step={step} />
    </Suspense>
  );
}
